import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * Lists all active locations
 * @returns {Promise<Location[]>}
 */
export async function fetchActive() {
  const resp = await fetch(`${HOST}/api/v1/locations/active`);
  const data = await resp.json();
  return data;
}

/**
 * Lists all locations for the superuser
 * @param {object} accessToken
 * @returns {Promise<Array<ManagerLocation>>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/locations`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  const data = await resp.json();
  console.log(data);
  return data;
}

/**
 * @param {object} accessToken
 * @param {SaveOrUpdateLocationRequest} req
 */
export async function saveOrUpdate(accessToken, req) {
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/locations`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    const body = await resp.json();
    // Extract validation error messages
    const errors = body?.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      const messages = errors
        .map((e) => e.comment || e.error || "")
        .filter(Boolean)
        .join("; ");
      throw new Error(messages || JSON.stringify(body));
    }
    throw new Error(JSON.stringify(body));
  }
}

/**
 * @param {object} accessToken
 * @param {number} locationId
 */
export async function archive(accessToken, locationId) {
  const opts = { method: "DELETE" };
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/${locationId}`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status !== 200) {
    throw await resp.text();
  }
}
